<template>
  <div v-if="shows" ref="context-menu" class="context-menu" v-click-outside="onClickOutside">
    <div class="context-menu-popover" @click="closeMenu">
      <div class="context-menu-content" :style="{'flex-direction': direction, 'width': width+'px'}">
        <slot>
          <ContextMenuItem :label="'No actions'">
          </ContextMenuItem>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import ContextMenuItem from "./ContextMenuItem";

export default {
  components: { ContextMenuItem },
  props: {
    direction: {
      type: String,
      default: "column",
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      shows: false,
      menuWidth: null,
      menuHeight: null,
      contentWidth: this.width,
      contentHeight: this.height,
    };
  },
  methods: {
    openMenu () {
      this.shows = true;
      this.$nextTick(function () {
        let menu = this.$refs["context-menu"];
        if (!menu) {
          return;
        }
        menu.parentNode.removeChild(menu);
        document.body.appendChild(menu);
        const popover = menu.getElementsByClassName("context-menu-popover")[0];
        if (!this.menuWidth || !this.menuHeight) {
          menu.style.visibility = "hidden";
          menu.style.display = "block";
          this.menuWidth = menu.offsetWidth;
          this.menuHeight = menu.offsetHeight;
          menu.removeAttribute("style");
        }
        popover.style.height = 0;
        popover.style.padding = 0;
        popover.style.marginTop = (this.menuHeight / 2) + "px";
        popover.style.marginBottom = (this.menuHeight / 2) + "px";
        const xCoord = this.$store.state.contextMenu.position.x
        const yCoord = this.$store.state.contextMenu.position.y
        if ((this.menuWidth + xCoord - window.scrollX) >= window.innerWidth) {
          menu.style.left = (xCoord - this.menuWidth - 1) + "px";
        } else {
          menu.style.left = (xCoord + 1) + "px";
        }
        if ((this.menuHeight + yCoord - window.scrollY) >= window.innerHeight) {
          menu.style.top = (yCoord - this.menuHeight - 1) + "px";
        } else {
          menu.style.top = (yCoord - this.menuHeight / 2) + "px";
        }
        this.$nextTick(function () {
          popover.style.transitionProperty = "height, margin, padding";
          popover.style.transitionDuration = "0.2s";
          popover.style.padding = null;
          popover.style.height = (this.menuHeight) + "px";
          popover.style.marginTop = 0;
          popover.style.marginBottom = 0;
        });
      });
    },
    closeMenu () {
      this.$emit("close");
      this.shows = false;
    },
    onClickOutside () {
      if (this.shows) {
        this.$emit("click-outside");
        this.closeMenu();
      }
    },
    optionClicked (option) {
      this.closeMenu();
      this.$emit("option-clicked", {
        item: this.item,
        option: option,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.context-menu {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 0;
  z-index: $zindex-dropdown;
}

.context-menu-popover {
  background-color: white;
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
  padding: 8px;
}

.context-menu-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
